import { ViewModel, View, ObservableArray } from "binder"
import { DistrictSalesTabView } from "./districtSalesTab-view"
import { CompareDistrictSalesViewModel, DistrictCancelInvoicePerPersonnel, DistrictInvoicePerCustomer, DistrictInvoicePerPersonnel, DistrictReturnInvoicePerPersonnel, DistrictSale, ListHunt } from "../compareDistrictSales/compareDistrictSales-viewModel";
import moment from "moment";
import { ServerConnection } from "src/server/serverConnection";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class DistrictSalesTabViewModel extends ViewModel {
    GetDefaultView(): View<ViewModel> {
        return new DistrictSalesTabView();
    }
    public getTypeId(): string {
        return "VM-9E152131-CAEB-4BE1-BCE5-CA0403B6F20B"
    }
    constructor(parent: CompareDistrictSalesViewModel) {
        super(parent);
        this.loaderAllDistrict = new ServerSideDataLoader(filteringInformation => this.getAllDistrictSales(filteringInformation), 150);
        this.districtSales = ObservableArray.create<DistrictSale>();
        this._parentViewModel = parent;
        this.tabName = 'اتوپارت';
    }

    public set tabName(v: string) { this._tabName = v; } public get tabName(): string { return this._tabName; } private _tabName: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set loaderAllDistrict(v: ServerSideDataLoader) { this._loaderAllDistrict = v; } public get loaderAllDistrict(): ServerSideDataLoader { return this._loaderAllDistrict; } private _loaderAllDistrict: ServerSideDataLoader;
    public set districtSales(v: ObservableArray<DistrictSale>) { this._districtSales = v; } public get districtSales(): ObservableArray<DistrictSale> { return this._districtSales; } private _districtSales: ObservableArray<DistrictSale>;

    public set car(v: string) { this._car = v; } public get car(): string { return this._car;} private _car: string;
    public set carName(v: string) { this._carName = v; } public get carName(): string { return this._carName;} private _carName: string;
   
    public set totalCallsCount(v: number) { this._totalCallsCount = v; } public get totalCallsCount(): number { return this._totalCallsCount; } private _totalCallsCount: number;
    public set totalHuntCount(v: number) { this._totalHuntCount = v; } public get totalHuntCount(): number { return this._totalHuntCount; } private _totalHuntCount: number;
    public set totalSaleInvoicesCount(v: number) { this._totalSaleInvoicesCount = v; } public get totalSaleInvoicesCount(): number { return this._totalSaleInvoicesCount; } private _totalSaleInvoicesCount: number;
    public set totalSaleInvoicesFinalPrice(v: number) { this._totalSaleInvoicesFinalPrice = v; } public get totalSaleInvoicesFinalPrice(): number { return this._totalSaleInvoicesFinalPrice; } private _totalSaleInvoicesFinalPrice: number;
    public set totalSaleInvoicesAmount(v: number) { this._totalSaleInvoicesAmount = v; } public get totalSaleInvoicesAmount(): number { return this._totalSaleInvoicesAmount; } private _totalSaleInvoicesAmount: number;
    public set totalReturnInvoicesCount(v: number) { this._totalReturnInvoicesCount = v; } public get totalReturnInvoicesCount(): number { return this._totalReturnInvoicesCount; } private _totalReturnInvoicesCount: number;
    public set totalReturnInvoicesFinalPrice(v: number) { this._totalReturnInvoicesFinalPrice = v; } public get totalReturnInvoicesFinalPrice(): number { return this._totalReturnInvoicesFinalPrice; } private _totalReturnInvoicesFinalPrice: number;
    public set totalCancelInvoicesCount(v: number) { this._totalCancelInvoicesCount = v; } public get totalCancelInvoicesCount(): number { return this._totalCancelInvoicesCount; } private _totalCancelInvoicesCount: number;
    public set totalCancelInvoicesFinalPrice(v: number) { this._totalCancelInvoicesFinalPrice = v; } public get totalCancelInvoicesFinalPrice(): number { return this._totalCancelInvoicesFinalPrice; } private _totalCancelInvoicesFinalPrice: number;
    public set totalMonthSaleInvoicesFinalPrice(v: number) { this._totalMonthSaleInvoicesFinalPrice = v; } public get totalMonthSaleInvoicesFinalPrice(): number { return this._totalMonthSaleInvoicesFinalPrice; } private _totalMonthSaleInvoicesFinalPrice: number;
    public set totalSaleTarget(v: number) { this._totalSaleTarget = v; } public get totalSaleTarget(): number { return this._totalSaleTarget; } private _totalSaleTarget: number;

    private _parentViewModel: CompareDistrictSalesViewModel;
    public async load() {
        this.loaderAllDistrict.refresh();
    }

    async getAllDistrictSales(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result;
            if (stringIsNullOrEmpty(this.car)) {
                result = await ServerConnection.callServer('/Complex/ReportServices/AllDistrictSales', {
                    From: this._parentViewModel.from,
                    Until: this._parentViewModel.until
                });
            } else {
                result = await ServerConnection.callServer('/Complex/ReportServices/AllDistrictSalesPerCarBrand', {
                    From: this._parentViewModel.from,
                    Until: this._parentViewModel.until,
                    CarBrandId: this.car
                });
            }
            this.districtSales.update(...result.DistrictSales.map((q, rowNumber) => {
                let r = new DistrictSale(this._parentViewModel);
                r.rowNumber = rowNumber + 1;
                r.customerName = q.CustomerName;
                r.districtName = q.DistrictName;
                r.callsCount = q.CallsCount;
                r.huntCount = q.HuntsCount;
                r.saleInvoicesCount = q.SaleInvoicesCount;
                r.saleInvoicesFinalPrice = q.SaleInvoicesFinalPrice;
                r.saleInvoicesAmount = q.SaleInvoicesAmount;
                r.returnInvoicesCount = q.ReturnInvoicesCount;
                r.returnInvoicesFinalPrice = q.ReturnInvoicesFinalPrice;
                r.cancelInvoicesCount = q.CancelInvoicesCount;
                r.cancelInvoicesFinalPrice = q.CancelInvoicesFinalPrice;
                r.monthSaleInvoicesFinalPrice = q.MonthSaleInvoicesFinalPrice;
                r.districtInvoicesPerCustomer.update(...q.DistrictInvoicesPerCustomer.map(p => {
                    let d = new DistrictInvoicePerCustomer(this);
                    d.customerName = p.CustomerName;
                    d.saleInvoicesAmount = p.SaleInvoicesAmount;
                    d.saleInvoicesFinalPrice = p.SaleInvoicesFinalPrice;
                    d.saleInvoicesCount = p.SaleInvoicesCount;
                    d.saleInvoiceItemsCount = p.SaleInvoiceItemsCount;
                    return d;
                }));
                r.monthSaleInvoicesPerCustomer.update(...q.MonthSaleInvoicesPerCustomer.map(p => {
                    let d = new DistrictInvoicePerCustomer(this);
                    d.customerName = p.CustomerName;
                    d.saleInvoicesAmount = p.SaleInvoicesAmount;
                    d.saleInvoicesFinalPrice = p.SaleInvoicesFinalPrice;
                    d.saleInvoicesCount = p.SaleInvoicesCount;
                    d.saleInvoiceItemsCount = p.SaleInvoiceItemsCount;
                    return d;
                }));
                r.listHunts.update(...q.HuntsPerPersonnel.map(p => {
                    let d = new ListHunt(this);
                    d.personnelName = p.PersonnelName;
                    d.huntCount = p.HuntCount;
                    return d;
                }));
                r.districtInvoicesPerPersonnel.update(...q.DistrictInvoicesPerPersonnel.map(p => {
                    let d = new DistrictInvoicePerPersonnel(this);
                    d.personnelName = p.PersonnelName;
                    d.saleInvoicesAmount = p.SaleInvoicesAmount;
                    d.saleInvoicesFinalPrice = p.SaleInvoicesFinalPrice;
                    d.saleInvoicesCount = p.SaleInvoicesCount;
                    d.saleInvoiceItemsCount = p.SaleInvoiceItemsCount;
                    return d;
                }));
                r.districtReturnInvoicesPerPersonnel.update(...q.DistrictReturnInvoicesPerPersonnel.map(p => {
                    let d = new DistrictReturnInvoicePerPersonnel(this);
                    d.customerName = p.CustomerName;
                    d.personnelName = p.PersonnelName;
                    d.invoiceNumber = p.InvoiceNumber;
                    d.creationTime = moment.utc(p.CreatedDate);
                    d.returnInvoicesAmount = p.ReturnInvoicesAmount;
                    d.returnInvoicesFinalPrice = p.ReturnInvoicesFinalPrice;
                    d.returnInvoicesFeePrice = p.ReturnInvoicesFeePrice;
                    d.productCode = p.ProductCode;
                    d.productName = p.ProductName;
                    return d;
                }));
                r.districtCancelInvoicesPerPersonnel.update(...q.DistrictCancelInvoicesPerPersonnel.map(p => {
                    let d = new DistrictCancelInvoicePerPersonnel(this);
                    d.customerName = p.CustomerName;
                    d.personnelName = p.PersonnelName;
                    d.invoiceNumber = p.InvoiceNumber;
                    d.creationTime = moment.utc(p.CreatedDate);
                    d.canceledInvoicesAmount = p.CanceledInvoicesAmount;
                    d.canceledInvoicesFinalPrice = p.CanceledInvoicesFinalPrice;
                    d.canceledInvoicesFeePrice = p.CanceledInvoicesFeePrice;
                    d.productCode = p.ProductCode;
                    d.productName = p.ProductName;
                    return d;
                }));
                r.saleTarget = q.SaleTarget;
                return r;
            }));
            this.totalCallsCount = this.districtSales.reduce((a, c) => a + c.callsCount, 0);
            this.totalHuntCount = this.districtSales.reduce((a, c) => a + c.huntCount, 0);
            this.totalSaleInvoicesCount = this.districtSales.reduce((a, c) => a + c.saleInvoicesCount, 0);
            this.totalSaleInvoicesFinalPrice = this.districtSales.reduce((a, c) => a + c.saleInvoicesFinalPrice, 0);
            this.totalSaleInvoicesAmount = this.districtSales.reduce((a, c) => a + c.saleInvoicesAmount, 0);
            this.totalReturnInvoicesCount = this.districtSales.reduce((a, c) => a + c.returnInvoicesCount, 0);
            this.totalReturnInvoicesFinalPrice = this.districtSales.reduce((a, c) => a + c.returnInvoicesFinalPrice, 0);
            this.totalCancelInvoicesCount = this.districtSales.reduce((a, c) => a + c.cancelInvoicesCount, 0);
            this.totalCancelInvoicesFinalPrice = this.districtSales.reduce((a, c) => a + c.cancelInvoicesFinalPrice, 0);
            this.totalMonthSaleInvoicesFinalPrice = this.districtSales.reduce((a, c) => a + c.monthSaleInvoicesFinalPrice, 0);
            this.totalSaleTarget = this.districtSales.reduce((a, c) => a + c.saleTarget, 0);
            return new PaginationInfo(1, 1);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

}
